export const Rentner = [
  {
    'PAISY Wert': 1,
    Bezeichnung: 'Rentenantrag',
  },
  {
    'PAISY Wert': 2,
    Bezeichnung: 'teilw. Erw.mind.',
  },
  {
    'PAISY Wert': 3,
    Bezeichnung: 'volle Erw.mind.',
  },
  {
    'PAISY Wert': 4,
    Bezeichnung: 'Altersvollrente',
  },
  {
    'PAISY Wert': 5,
    Bezeichnung: 'Altersteilrente',
  },
  {
    'PAISY Wert': 6,
    Bezeichnung: 'Hinterbl.rente',
  },
  {
    'PAISY Wert': 7,
    Bezeichnung: 'Erziehungsrente',
  },
  {
    'PAISY Wert': 8,
    Bezeichnung: 'R. f. Bergleute',
  },
  {
    'PAISY Wert': 9,
    Bezeichnung: 'Landabgaberente',
  },
  {
    'PAISY Wert': 0,
    Bezeichnung: 'kein Rentner',
  },
];
